const {
  DataInventoryServiceIdToName,
  DataInventoryServiceIdToCodeName,
  DataInventoryServiceIds,
  DataInventoryServiceNames,
  DataInventoryServiceCodeNames,
  invert,
} = require('../../shared/constants');

const Sftp05RelatedTasks = {
  SFTP05_DISCONNECT_GROUP: 'disconnect-group-sftp05',
  SFTP05_RECONCILIATION: 'sftp05-reconciliation',
  SFTP05_GROUP_RECONCILIATION: 'sftp05-group-reconciliation',
};

const IndependentSystemTasks = {
  COGNITO_USER_SYNC: 'cognito-users-sync',
  DATA_INVENTORY_SYNC_AWS_LAKE: 'aws-lake-inventory-sync',
  DATA_INVENTORY_SYNC_ARBITRATED_PCAPS: 'aws-arbitrated-pcaps-inventory-sync',
  DATA_INVENTORY_SYNC_SFTP05: 'data-inventory-sync',
  CRUSHFTP_GROUP_RECONCILIATION: 'crushftp-group-reconciliation',
  CRUSHFTP_RECONCILIATION: 'crushftp-reconciliation',
  CRUSHFTP_DISCONNECT_GROUP: 'disconnect-group-crushftp',
  AWS_GROUP_RECONCILIATION: 'aws-group-reconciliation',
  AWS_GROUP_ACCESS_GRANTS_CLEANUP: 'aws-group-access-grants-cleanup',
  AWS_RECONCILIATION: 'aws-reconciliation',
  OBJECT_RESTORE: 'object-restore',
  OBJECT_COUNT: 'object-count',
  OBJECT_STATUS: 'object-status',
  SFTP05_ALLOWLIST_SYNC: 'sftp-allowlist-sync',
  SFTP05_UPDATE_DATA_FEED_SET: 'update-data-feed-set-on-sftp05',
  LICENSE_EXPIRATION_CHECK: 'license-expiration-check',
};

const TasksToCaptureFailures = [
  IndependentSystemTasks.COGNITO_USER_SYNC,
  IndependentSystemTasks.DATA_INVENTORY_SYNC_AWS_LAKE,
  IndependentSystemTasks.DATA_INVENTORY_SYNC_ARBITRATED_PCAPS,
  IndependentSystemTasks.AWS_GROUP_RECONCILIATION,
  IndependentSystemTasks.AWS_RECONCILIATION,
  IndependentSystemTasks.LICENSE_EXPIRATION_CHECK,
];

const InventoryEvents = {
  DATA_INVENTORY_CACHE_UPDATED: 'data-inventory-cache-updated',
};

const EmailNotificationTemplateNames = {
  TASK_FAILURE: 'task-failure',
  ROLE_OR_POLICY_SYNC_FAILURE: 'role-or-policy-sync-failure',
  LICENSE_EXPIRATION: 'license-expiration',
  SLA_BREACH: 'sla-breach-notification',
};

const EmailNotificationSubjects = {
  [EmailNotificationTemplateNames.TASK_FAILURE]: '[Error] MACE Task Failed',
  [EmailNotificationTemplateNames.ROLE_OR_POLICY_SYNC_FAILURE]: '[Failure] Failed to sync customer entitlements to AWS',
  [EmailNotificationTemplateNames.SLA_BREACH]: '[Alert] MACE Data Feed Delay Detected',
};

const LicenseExpirationNotificationSubjects = {
  warning: '[Important] MACE: Licenses Reached Expiration Notice Period',
  none: '[Info] MACE: No Licenses Reached Expiration Notice Period',
  failed: '[Important] MACE: License Expiration Check Failed',
};

const RedisKeys = {
  DATA_INVENTORY_CACHE: 'data-inventory-cache',
};

const PermissionTypes = {
  DATA_FEEDS_LAKE: 'data-feeds-lake',
  DATA_FEEDS_AWS_PCAP: 'data-feeds-aws-arbitrated-pcaps',
  DATA_FEEDS_SFTP05: 'data-feeds-sftp05',
  DATA_FEEDS_CRUSHFTP: 'data-feeds-crushftp',
  DATA_FEEDS_AWS_RAW: 'data-feeds-aws-raw',
  WORKBENCH: 'workbench',
};

const PermissionTypesToInventoryServiceIds = {
  // comment is the old permissions
  // [PermissionTypes.DATA_FEEDS_SFTP05]: DataInventoryServiceIds.SFTP05,
  [PermissionTypes.DATA_FEEDS_CRUSHFTP]: DataInventoryServiceIds.SFTP05,
  [PermissionTypes.DATA_FEEDS_LAKE]: DataInventoryServiceIds.AWS_LAKE,
  [PermissionTypes.DATA_FEEDS_AWS_PCAP]: DataInventoryServiceIds.AWS_ARBITRATED_PCAPS,
  [PermissionTypes.DATA_FEEDS_AWS_RAW]: DataInventoryServiceIds.AWS_RAW_FEEDS,
  [PermissionTypes.WORKBENCH]: null,
};

const InventoryServiceIdsToPermissionTypes = invert(PermissionTypesToInventoryServiceIds);

module.exports = {
  DataInventoryServiceIds,
  DataInventoryServiceNames,
  DataInventoryServiceCodeNames,
  DataInventoryServiceIdToName,
  DataInventoryServiceIdToCodeName,
  EmailNotificationTemplateNames,
  EmailNotificationSubjects,
  LicenseExpirationNotificationSubjects,
  PermissionTypes,
  PermissionTypesToInventoryServiceIds,
  SystemTasks: {
    ...IndependentSystemTasks,
    ...Sftp05RelatedTasks,
  },
  TasksToCaptureFailures,
  IndependentSystemTasks,
  InventoryServiceIdsToPermissionTypes,
  Sftp05RelatedTasks,
  InventoryEvents,
  RedisKeys,
};
